import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27f8daec")

_pushScopeId("data-v-27f8daec")
const _hoisted_1 = { class: "t-center mt-24" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("New Order")
const _hoisted_3 = { class: "body" }
const _hoisted_4 = {
  class: "brief df-middle px-16",
  style: {"border-top":"1px solid #CFD8E3"}
}
const _hoisted_5 = { class: "flex-1 t-left" }
const _hoisted_6 = { class: "code" }
const _hoisted_7 = { class: "f-sm c-title" }
const _hoisted_8 = { class: "flex-1 t-right" }
const _hoisted_9 = { class: "detail br-lg df-middle" }
const _hoisted_10 = { class: "flex-1" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "f-bold mt-4" }, "$200", -1)
const _hoisted_12 = { class: "flex-1" }
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Buy")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Place Order")
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")
  const _component_t = _resolveComponent("t")
  const _component_Icon = _resolveComponent("Icon")
  const _component_RealTimeQuote = _resolveComponent("RealTimeQuote")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, { class: "bg-primary br-lg" }, {
    left: _withId(() => [
      _createVNode(_component_Pic, {
        src: "flow",
        width: "20",
        height: "20"
      })
    ]),
    title: _withId(() => [
      _createVNode(_component_t, {
        as: "p",
        path: "market_15",
        class: "c-white f-lg ml-20 py-20 t-left"
      })
    ]),
    right: _withId(() => [
      _createVNode(_component_Icon, {
        name: "close",
        class: "c-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      })
    ]),
    controls: _withId(() => [
      _hoisted_16
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_t, {
          as: "p",
          path: "market_16",
          class: "f-lg f-bold header"
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("p", _hoisted_6, _toDisplayString(_ctx.prop('code', _ctx.symbol)), 1),
              _createVNode("p", _hoisted_7, _toDisplayString(_ctx.tips), 1)
            ]),
            _createVNode(_component_RealTimeQuote, { symbol: _ctx.symbol }, {
              default: _withId(({margin, mp, isRise}) => [
                _createVNode("div", _hoisted_8, [
                  _createVNode("p", {
                    class: ["c-success", {' c-danger': !isRise}]
                  }, _toDisplayString(margin), 3),
                  _createVNode("span", {
                    class: [{danger: !_ctx.isUp}, "badge success"]
                  }, _toDisplayString(mp), 3)
                ])
              ]),
              _: 1
            }, 8, ["symbol"])
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_t, {
                as: "p",
                path: "market_17",
                class: "c-title"
              }),
              _hoisted_11
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_t, {
                as: "p",
                path: "market_18",
                class: "c-title"
              }),
              _createVNode("p", _hoisted_13, [
                _createVNode(_component_t, {
                  path: _ctx.isUp ? 'market_19': 'market_20',
                  class: "f-bold"
                }, {
                  default: _withId(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["path"]),
                _createVNode(_component_Icon, {
                  class: [{'bg-danger': !_ctx.isUp}, "bg-success ml-8"],
                  name: _ctx.isUp ? 'up' : 'down',
                  sm: "",
                  style: {"color":"white"}
                }, null, 8, ["class", "name"])
              ])
            ])
          ]),
          _createVNode(_component_t, {
            as: "p",
            path: _ctx.isUp ? 'market_21' : 'market_22',
            class: "t-left my-16 c-title",
            args: {symbol: _ctx.symbol.code}
          }, null, 8, ["path", "args"]),
          _createVNode(_component_Button, {
            progress: _ctx.progress,
            class: ["btn success block f-lg f-bold", {danger: !_ctx.isUp}],
            onClick: _ctx.create
          }, {
            default: _withId(() => [
              _createVNode(_component_t, { path: "market_23" }, {
                default: _withId(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["progress", "class", "onClick"])
        ])
      ])
    ]),
    _: 1
  }))
})